var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入入库单号" },
            model: {
              value: _vm.searchData.incomingNo,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "incomingNo", $$v)
              },
              expression: "searchData.incomingNo"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入序列号" },
            model: {
              value: _vm.searchData.sn,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "sn", $$v)
              },
              expression: "searchData.sn"
            }
          }),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择设备型号"
              },
              model: {
                value: _vm.searchData.deviceTypeCode,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "deviceTypeCode", $$v)
                },
                expression: "searchData.deviceTypeCode"
              }
            },
            _vm._l(_vm.droplist2, function(item, index) {
              return _c("el-option", {
                key: index,
                attrs: {
                  label: item.name + " (" + item.code + ")",
                  value: item.code
                }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择审核状态"
              },
              model: {
                value: _vm.searchData.auditStatus,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "auditStatus", $$v)
                },
                expression: "searchData.auditStatus"
              }
            },
            [
              _c("el-option", { attrs: { label: "已审核", value: "1" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "未审核", value: "0" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择服务区域"
              },
              model: {
                value: _vm.searchData.regionalId,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "regionalId", $$v)
                },
                expression: "searchData.regionalId"
              }
            },
            _vm._l(_vm.regionList, function(item, index) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.regionalName, value: item.id }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v("\n      入库时间：\n    "),
          _c("el-date-picker", {
            staticClass: "filter-item",
            attrs: {
              "value-format": "yyyy-MM-dd",
              type: "date",
              placeholder: "选择日期"
            },
            model: {
              value: _vm.searchData.startTime,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "startTime", $$v)
              },
              expression: "searchData.startTime"
            }
          }),
          _vm._v("\n    到\n    "),
          _c("el-date-picker", {
            staticClass: "filter-item",
            attrs: {
              type: "date",
              "value-format": "yyyy-MM-dd",
              placeholder: "选择日期"
            },
            model: {
              value: _vm.searchData.endTime,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "endTime", $$v)
              },
              expression: "searchData.endTime"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.searchFun }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.resetFun }
            },
            [_vm._v("重置")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _vm.checkPermission(["device:instorage:add"])
            ? _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "primary", icon: "el-icon-plus" },
                  on: { click: _vm.addFun }
                },
                [_vm._v("新增")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: ["api/faInstorageDetail/downloadTemp"],
                target: "_blank"
              }
            },
            [
              _vm.checkPermission(["device:instorage:export"])
                ? _c(
                    "el-button",
                    {
                      staticClass: "filter-item",
                      attrs: { type: "success", icon: "el-icon-printer" }
                    },
                    [_vm._v("下载入库导入表格")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.checkPermission(["device:instorage:fastadd"])
            ? _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "success", icon: "el-icon-printer" },
                  on: { click: _vm.fastAddFun }
                },
                [_vm._v("快速生成")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-dropdown",
            [
              _c(
                "el-button",
                {
                  staticClass: "filter-item",
                  attrs: { type: "primary", scoped: "" }
                },
                [
                  _vm._v("\n      显示/隐藏列\n      "),
                  _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                _vm._l(_vm.tableColumns, function(column, index) {
                  return _c(
                    "el-dropdown-item",
                    {
                      key: index,
                      nativeOn: {
                        click: function($event) {
                          return _vm.showHide(column.isShow)
                        }
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: column.isShow,
                            callback: function($$v) {
                              _vm.$set(column, "isShow", $$v)
                            },
                            expression: "column.isShow"
                          }
                        },
                        [_vm._v(_vm._s(column.label))]
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "cell-style": _vm.isCenter,
            "header-cell-style": _vm.isCenter,
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(column, index) {
            return [
              column.isShow
                ? _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      formatter: column.formatter,
                      width: column.width,
                      sortable: column.sortable
                    }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "280", prop: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.checkPermission(["device:instorage:del"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              title: "删除",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.delMenu(scope.row)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["device:instorage:examine"]) &&
                    scope.row.auditStatus == 0
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "success",
                              title: "审核",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.reviewMenu(scope.row)
                              }
                            }
                          },
                          [_vm._v("审核")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["device:instorage:examine"]) &&
                    scope.row.auditStatus == 1
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "warning",
                              title: "反审核",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.unReviewMenu(scope.row)
                              }
                            }
                          },
                          [_vm._v("反审核")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["device:instorage:code"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              title: "导出二维码",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.exportQRMenu(scope.row)
                              }
                            }
                          },
                          [_vm._v("导出二维码")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("p"),
                    _vm._v(" "),
                    _vm.checkPermission(["device:instorage:import"])
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              title: "导入Excel",
                              size: "mini"
                            },
                            on: {
                              click: function($event) {
                                return _vm.importExcel(scope.row)
                              }
                            }
                          },
                          [_vm._v("导入Excel")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkPermission(["device:instorage:edit"])
                      ? _c(
                          "router-link",
                          {
                            attrs: {
                              to:
                                "/device/informationdetail/" +
                                scope.row.id +
                                "/" +
                                scope.row.regionalId +
                                "/" +
                                scope.row.deviceTypeId
                            }
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { title: "入库明细", size: "mini" } },
                              [_vm._v("入库明细")]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total>0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            width: "500px",
            visible: _vm.newadd,
            "before-close": _vm.closeDiglog,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.newadd = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              staticClass: "mark",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "160px",
                size: "small"
              }
            },
            [
              _vm.title === "快速生成" || _vm.title === "新增"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "选择服务区域",
                        prop: "regionalId",
                        required: ""
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择服务区域"
                          },
                          model: {
                            value: _vm.addData.regionalId,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "regionalId", $$v)
                            },
                            expression: "addData.regionalId"
                          }
                        },
                        _vm._l(_vm.regionList, function(item, index) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.regionalName, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title === "快速生成"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "开始SN码：", prop: "startSn" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "17" },
                        model: {
                          value: _vm.addData.startSn,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "startSn", $$v)
                          },
                          expression: "addData.startSn"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title === "快速生成"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "生成数量(台)：", prop: "quantity" } },
                    [
                      _c("el-input", {
                        attrs: { maxlength: "5" },
                        model: {
                          value: _vm.addData.quantity,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "quantity", $$v)
                          },
                          expression: "addData.quantity"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "新增"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "设备型号：", prop: "deviceTypeId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            remote: "",
                            filterable: "",
                            "remote-method": _vm.getdrop
                          },
                          model: {
                            value: _vm.addData.deviceTypeId,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "deviceTypeId", $$v)
                            },
                            expression: "addData.deviceTypeId"
                          }
                        },
                        _vm._l(_vm.droplist, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.name + "/" + item.code,
                              value: item.id
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "快速生成"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "设备型号：", prop: "deviceTypeCode" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            id: "zdsc5",
                            remote: "",
                            filterable: "",
                            "remote-method": _vm.getdrop
                          },
                          model: {
                            value: _vm.addData.deviceTypeCode,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "deviceTypeCode", $$v)
                            },
                            expression: "addData.deviceTypeCode"
                          }
                        },
                        _vm._l(_vm.droplist, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.name + "/" + item.code,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title === "快速生成"
                ? _c(
                    "el-form-item",
                    { staticClass: "isblock", attrs: { label: "支持秘钥" } },
                    [
                      _c("el-checkbox", {
                        attrs: { "false-label": 0, "true-label": 1 },
                        model: {
                          value: _vm.addData.supportSecretKey,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "supportSecretKey", $$v)
                          },
                          expression: "addData.supportSecretKey"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "快速生成"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "备注：", prop: "desc" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 5,
                          id: "zdsc6",
                          maxlength: "100"
                        },
                        model: {
                          value: _vm.addData.desc,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "desc", $$v)
                          },
                          expression: "addData.desc"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "快速生成"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onFastSubmit }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "新增"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "备注:", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          autosize: { minRows: 5 },
                          placeholder: "请输入备注信息",
                          maxlength: "100"
                        },
                        model: {
                          value: _vm.addData.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.addData, "remark", $$v)
                          },
                          expression: "addData.remark"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "新增"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onSubmit }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.title == "修改"
                ? _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onUpdate }
                        },
                        [_vm._v("提交")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onCencal } }, [
                        _vm._v("取消")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导入Excel",
            width: "500px",
            visible: _vm.showImport,
            "before-close": _vm.closeImportDiglog,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.showImport = $event
            }
          }
        },
        [
          _vm.showImport
            ? _c(
                "el-form",
                {
                  ref: "importForm",
                  staticClass: "mark",
                  attrs: {
                    model: _vm.addData,
                    rules: _vm.rules,
                    "label-width": "160px",
                    size: "small"
                  }
                },
                [
                  _c("el-form-item", { attrs: { label: "导入Excel表:" } }, [
                    _c(
                      "input",
                      _vm._b(
                        {
                          attrs: {
                            type: "file",
                            prop: "file",
                            id: "daoru",
                            name: "file",
                            value: "",
                            accept:
                              ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          },
                          on: {
                            change: function($event) {
                              return _vm.getFile($event)
                            }
                          }
                        },
                        "input",
                        _vm.addData.file,
                        false
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: " " } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.onImport }
                        },
                        [_vm._v("导入")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.onImportCencal } }, [
                        _vm._v("关闭")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }